export const TAB_TRANSFERS_INCOMING = {
	IMPORTED: 'imported',
	WAITING: 'waiting',
	IN_SETTLEMENT: 'in-settlement',
	SETTLED: 'settled',
	OUTSIDE_FACTORING: 'outside-factoring',
};

export const TAB_TRANSFERS_OUTGOING = {
	TO_SIGN: 'to-sign',
	SIGNED: 'signed',
	BUFFER: 'buffer',
	SENT: 'sent',
	REALIZED: 'realized',
	UNREALIZED: 'unrealized',
	UNRELATED: 'unrelated',
	PROCESSING: 'processing',
};

export const STATUS_TRANSFERS_INCOMING = {
	IMPORTED: 0, // "Zaimportowany"
	WAITING: 1, // "Poczekalnia"
	OUTSIDE_FACTORING: 2, // "Poza faktoringiem"
	IN_SETTLEMENT: 3, // "W rozliczeniu"
	SETTLED: 4, // "Rozliczony"
};

export const STATUS_TRANSFERS_OUTGOING = {
	BUFFER: 0, // "W buforze"
	SENT: 1, // "Wysłany do banku"
	REALIZED: 2, // "Zrealizowany"
	UNREALIZED: 3, // "Niezrealizowany"
	NOT_RELATED: 4, // "Niepowiązany"
};

export const TRANSFERS_TYPE = {
	OUTGOING: 1, // "Wychodzący"
	INCOMING: 2 // "Przychodzący"
};

export const TRANSFERS_TYPE_FILE = {
	IMPORT: 1, // "Plik importu"
	EXPORT: 2 // "Plik eksportu"
};

export const TRANSFERS_KIND = {
	INVOICE: 0, // "Faktura"
	REFUND: 1, // "Zwrot"
	TRANSFER: 2, // "Przekaz"
};
